// extracted by mini-css-extract-plugin
export default {"holder":"Input_holder__Q4mWU","icon":"Input_icon__qa-qI","input":"Input_input__5+78Q","invalid":"Input_invalid__mU7zE"};